/**
 * Las dos vistas de Inventario: el stock de cada producto y la libreta de
 * movimientos. Son enlaces y no pestanas de ARIA: cada una tiene su URL, se
 * puede recargar, compartir y volver con "Atras". Cambiar de vista arranca la
 * otra sin filtros.
 */
import { Link } from 'react-router-dom';

import type { VistaInventario } from '../../utilidades/filtros-inventario';
import { PARAMETRO_VISTA } from '../../utilidades/filtros-inventario';
import { rutas } from '../../utilidades/rutas';

export interface PestanasInventarioProps {
  vista: VistaInventario;
}

const VISTAS: { vista: VistaInventario; texto: string }[] = [
  { vista: 'stock', texto: 'Stock' },
  { vista: 'movimientos', texto: 'Movimientos' },
];

export function PestanasInventario({ vista }: PestanasInventarioProps) {
  return (
    <nav className="pestanas-admin" aria-label="Vistas del inventario">
      {VISTAS.map((opcion) => (
        <Link
          key={opcion.vista}
          className={opcion.vista === vista ? 'pestana-admin activa' : 'pestana-admin'}
          aria-current={opcion.vista === vista ? 'page' : undefined}
          to={
            opcion.vista === 'stock'
              ? rutas.administracion.inventario()
              : `${rutas.administracion.inventario()}?${PARAMETRO_VISTA}=movimientos`
          }
        >
          {opcion.texto}
        </Link>
      ))}
    </nav>
  );
}
